import React from 'react';
import { Select, SelectProps } from 'antd';
import { ArrowDownIcon } from 'assets/icons/arrow-down';

interface SortedSelectProps extends Omit<SelectProps, 'size' | 'suffixIcon'> {
  size?: SelectProps['size'];
  suffixIcon?: React.ReactNode;
  options: SelectProps['options'];
}

export const SortedSelect: React.FC<SortedSelectProps> = ({
  options = [],
  size = 'large',
  suffixIcon = <ArrowDownIcon />,
  ...props
}) => {
  const sortedOptions = React.useMemo(() => {
    if (!options || !Array.isArray(options)) return [];

    return [...options].sort((a, b) => {
      const labelA =
        typeof a.label === 'string' ? a.label : String(a.label || '');
      const labelB =
        typeof b.label === 'string' ? b.label : String(b.label || '');
      return labelA.localeCompare(labelB);
    });
  }, [options]);

  return (
    <Select
      size={size}
      suffixIcon={suffixIcon}
      options={sortedOptions}
      {...props}
    />
  );
};
